import { CrystalWithResultDTO } from 'business/models/Models';
import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import {
  setSelectedCrystalId,
  setSelectedTripResultIDs,
} from 'redux/reducers/synchrotronTripReducer';
import { useSelectedCrystalId } from '../hooks';
import SynchrotronTripResultForm from './synchrotronTripResultForm';
import { TableColumns } from '../utils';
import { resultTableColumns } from './utils';

interface CollectedCrystalsProps {
  crystals: CrystalWithResultDTO[];
  handleInputChange?: (e: any, id: number) => void;
  refetch?: () => void;
  isReadOnly?: boolean;
}

const SynchrotronTripResults = (props: CollectedCrystalsProps) => {
  const { crystals, handleInputChange, isReadOnly } = props;
  const [selectedRows, setSelectedRows] = useState<number[]>();
  const [crystal, setCrystal] = useState<CrystalWithResultDTO>();
  const tableColumns_: TableColumns[] = resultTableColumns;
  const dispatch = useRMDispatch();
  const [crystalId] = useSelectedCrystalId();

  const handleSelectionChange = useCallback(
    (rowIndices: number[]) => {
      const selectedTripIds = rowIndices.map((idx) => crystals[idx]?.id);
      setSelectedRows([...rowIndices]);
      dispatch(setSelectedTripResultIDs(selectedTripIds));
      dispatch(setSelectedCrystalId(crystals[rowIndices.pop()]?.id));
    },
    [crystals],
  );

  const crystalList = useMemo(
    () =>
      crystals?.map((c: CrystalWithResultDTO) => ({
        id: c.id,
        crystalName: c.crystalName,
        owner: c.owner,
        puckName: c.puckName,
        puckBarcode: c.puckBarcode,
        position: c.position,
        dewarName: c.dewarName,
        resultStatus: c.resultStatus,
      })),
    [crystals],
  );

  const handleOnRowCLick = (row) => {
    setSelectedRows([row.index]);
    dispatch(setSelectedTripResultIDs([crystals[row.index]?.id]));
    dispatch(setSelectedCrystalId(crystals[row.index]?.id));
  };

  useEffect(() => {
    if (crystalId) {
      setCrystal(crystals.find((c) => c.id === crystalId));
    }
  }, [crystals, crystalId]);

  useEffect(() => {
    dispatch(setSelectedCrystalId(0));
  }, []);

  return (
    <>
      <div id="tripresult-synchrotrontripresult-wrapper" className="synch_td h-72">
        <div
          id="tripresult-synchrotrontripresult-title"
          className="text-lg font-bold w-1/2"
        >
          Synchrotron Trip Results ({crystals?.length})
        </div>
        <div
          id="tripresult-synchrotrontripresult-tables"
          className="h-[15rem] overflow-auto p-0.5"
        >
          <RMTable
            columns={[...tableColumns_]}
            data={crystalList}
            selectedIds={selectedRows}
            onCheckboxSelectionChange={handleSelectionChange}
            onRowClicked={handleOnRowCLick}
            enableMultiSelection
            tableClass="w-full"
          />
        </div>
      </div>
      <div id="tripresult-synchrotrontripresult-form" className="mt-3">
        {crystalId ? (
          <>
            <SynchrotronTripResultForm
              crystal={crystal}
              handleInputChange={handleInputChange}
              isReadOnly={isReadOnly}
            />
          </>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default SynchrotronTripResults;
